module.exports = __webpack_public_path__ + "img/视频封面21.b22a8f27.png";